import { useLocation, useNavigate, useParams } from 'react-router-dom'
import useGetTableIndex from '../../../../../core/hooks/layout/useGetTableIndex'
import TableLayout from '../../../../layout/main/TableLayout'
import { formatName, getNames } from '../../../../../core/utils/common'
import { Column, Row } from '../../../../../styles/CommonStyles'
import DateTime from '../../../../common/utils/DateTime'
import UserLink from '../../../../common/utils/UserLink'
import { userAffiliatesAttributes } from '../../../../../core/constants/headers'


const AffiliatesTable = ({ data }) => {

    const params = useParams()
    const { data: affiliates } = data
    const { cs, headers } = userAffiliatesAttributes
    const location = useLocation()
    const navigate = useNavigate()
    console.log(affiliates);

    const { getTableIndex } = useGetTableIndex()

    return (
        <TableLayout
            headers={headers}
            cs={cs}
            data={data}
            hasWriteAccess
        >
            {affiliates?.data?.map((affiliate, idx) => {

                const {
                    FULLNAME
                } = getNames(
                    affiliate?.firstName,
                    affiliate?.lastName
                )

                return (
                    <Row cs={cs} index={idx} key={affiliate._id}>
                        <Column>
                            {getTableIndex(idx)}
                        </Column>
                        <Column>
                            <UserLink
                                _id={affiliate._id}
                                name={affiliate._id}
                            />
                        </Column>
                        <Column>
                            <UserLink
                                _id={affiliate._id}
                                name={formatName(FULLNAME)}
                            />
                        </Column>
                        <Column>
                            {affiliate.mobile || '-'}
                        </Column>
                        <Column center>
                            <DateTime dt={affiliate.createdAt} />
                        </Column>

                    </Row>
                )
            })}
        </TableLayout>
    )

}



export default AffiliatesTable
